import React from 'react';

const Terms = () => {
  return (
    <div className="legal-page">
      <section className="hero">
        <div className="container">
          <h1>Terms of Service</h1>
          <p>Terms governing use of our website and software delivery services.</p>
        </div>
      </section>
      <section className="section">
        <div className="container legal-content">
          <h2>Service Scope</h2>
          <p>Project scope, timeline, and pricing are finalized in signed proposals and statements of work.</p>
          <h2>Intellectual Property</h2>
          <p>Ownership, licensing, and source handover are defined per contract terms.</p>
          <h2>Limitations</h2>
          <p>We are not liable for indirect losses, downtime from third-party systems, or force majeure events.</p>
        </div>
      </section>
    </div>
  );
};

export default Terms;

